import { Link } from "react-router-dom";
import { Phone, Wrench } from "lucide-react";

const COMPANY_LINKS = [
  { label: "Home", to: "/" },
  { label: "Contact", href: "#footer" },
  { label: "Service Areas", href: "#service-areas" },
];

const INFO_LINKS = [
  { label: "License", href: "#" },
  { label: "Reviews", href: "#reviews" },
];

const SERVICE_LINKS = [
  { label: "Emergency Plumbing", to: "/services/emergency-plumbing" },
  { label: "Shower Head Repair", to: "/services/shower-head-repair" },
  { label: "Water Heater Repair", to: "/services/water-heater-services" },
  { label: "Leak Detection & Repair", to: "/services/leak-detection-repair" },
  { label: "Toilet & Fixture Repair", to: "/services/toilet-fixture-repair" },
  { label: "View All Services", to: "/services" },
];

const LOCATION_LINKS = [
  { label: "Lincoln Park", to: "/locations/lincoln-park" },
  { label: "Lakeview", to: "/locations/lakeview" },
  { label: "Logan Square", to: "/locations/logan-square" },
  { label: "River North", to: "/locations/river-north" },
  { label: "South Loop", to: "/locations/south-loop" },
  { label: "Old Town", to: "/locations/old-town" },
  { label: "Gold Coast", to: "/locations/gold-coast" },
  { label: "View All Locations", to: "/locations" },
];

function FooterLink({ item }) {
  const cls = "text-white/70 hover:text-white transition-colors text-sm";
  if (item.to) return <Link to={item.to} className={cls}>{item.label}</Link>;
  return <a href={item.href} className={cls}>{item.label}</a>;
}

function FooterLinkGroup({ title, links }) {
  return (
    <div className="space-y-3">
      <h3 className="font-bold text-white text-sm tracking-widest uppercase">{title}</h3>
      <ul className="space-y-2">
        {links.map((item) => (
          <li key={item.label}>
            <FooterLink item={item} />
          </li>
        ))}
      </ul>
    </div>
  );
}

function ContactForm({ id }) {
  return (
    <form
      action="https://formspree.io/f/mvzboapz"
      method="POST"
      autoComplete="off"
      className="bg-white rounded-2xl p-6 shadow-xl space-y-4"
    >
      <div className="flex flex-col gap-1.5">
        <label htmlFor={`name-${id}`} className="text-xs font-bold text-gray-700 uppercase tracking-wider">Full Name</label>
        <input required type="text" name="name" id={`name-${id}`} className="border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="flex flex-col gap-1.5">
          <label htmlFor={`Phone${id}`} className="text-xs font-bold text-gray-700 uppercase tracking-wider">Phone</label>
          <input required type="tel" name="Phone" id={`Phone-${id}`} className="border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500" />
        </div>
        <div className="flex flex-col gap-1.5">
          <label htmlFor={`email-${id}`} className="text-xs font-bold text-gray-700 uppercase tracking-wider">Email</label>
          <input type="email" name="email" id={`email-${id}`} className="border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500" />
        </div>
      </div>
      <div className="flex flex-col gap-1.5">
        <label htmlFor={`address-${id}`} className="text-xs font-bold text-gray-700 uppercase tracking-wider">Address</label>
        <input required type="text" name="address" id={`address-${id}`} className="border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500" />
      </div>
      <div className="flex flex-col gap-1.5">
        <label htmlFor={`desc-${id}`} className="text-xs font-bold text-gray-700 uppercase tracking-wider">Problem Description</label>
        <textarea name="problem-desc" id={`desc-${id}`} rows={5} className="border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none" />
      </div>
      <button
        type="submit"
        className="w-full bg-blue-600 hover:bg-blue-700 transition-colors text-white font-bold py-3.5 rounded-xl shadow-md shadow-blue-900/30 text-sm"
      >
        Get Problem Fixed
      </button>
    </form>
  );
}

export default function Footer() {
  return (
    <footer id="footer" className="bg-[#0f172a]">
      <div className="max-w-[90%] xl:max-w-6xl mx-auto">

        {/* ── Main footer grid ── */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 py-14">

          {/* Left: brand + links */}
          <div className="space-y-10">
            {/* Brand */}
            <div className="space-y-3">
              <div className="flex items-center gap-2.5">
                <span className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Wrench className="w-4 h-4 text-white" />
                </span>
                <h2 className="font-black text-white text-2xl tracking-tight">Chicago Plumbing</h2>
              </div>
              <p className="text-white/60 text-sm leading-relaxed max-w-xs">
                Reliable plumbing for homes and businesses. Quality work, clear pricing, and fast response — every time.
              </p>
              <a
               href="tel:(312) 555-0147"
  className="inline-flex items-center gap-2 text-sm font-bold text-blue-600 hover:text-blue-700 transition-colors bg-white px-4 py-2.5 rounded-xl"
>
  <Phone className="w-4 h-4" /> (312) 555-0147
</a>
            </div>

            {/* Link columns */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
              <FooterLinkGroup title="Company" links={COMPANY_LINKS} />
              <FooterLinkGroup title="Info" links={INFO_LINKS} />
              <FooterLinkGroup title="Services" links={SERVICE_LINKS} />
              <FooterLinkGroup title="Locations" links={LOCATION_LINKS} />
            </div>
          </div>

          {/* Right: contact form */}
          <div className="space-y-4">
            <div>
              <h4 className="font-black text-white text-2xl tracking-tight">Got a Problem?</h4>
              <p className="text-white/50 text-sm mt-1">Fill out the form and we'll get it fixed.</p>
            </div>
            <ContactForm id="desktop" />
          </div>
        </div>

        {/* ── Bottom bar ── */}
        <div className="border-t border-white/10 py-5 flex items-center justify-between gap-4 flex-wrap">
          <p className="text-white/40 text-xs">© {new Date().getFullYear()} Chicago Plumbing. All rights reserved.</p>
          <p className="text-white/40 text-xs">
            Built by{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://github.com/ammarrusesthis00"
              className="text-white/60 hover:text-white transition-colors underline"
            >
              Ammar
            </a>
          </p>
        </div>

      </div>
    </footer>
  );
}